import { MontageLayout, PlateDimensions } from '~/api/backend/commonTypes'

/**
 * Maps a MontageLayout to its number of rows and columns.
 *
 * Note: This might not contain all MontageLayout cases! We think it's likely
 * that we'll support non-rectangular montage layouts eventually. When that time
 * comes, we'll need more UI logic than just a simple grid.
 */
export const MONTAGE_LAYOUT_ROWS_COLS = {
  SINGLE: [1, 1],
  SQUARE_2X2: [2, 2],
  SQUARE_3X3: [3, 3],
  SQUARE_4X4: [4, 4],
}

/**
 * Maps a plate format (expressed as number of wells) to a reasonable default
 * montage layout. This is only applicable when we're missing image data, such
 * as in loading states.
 */
export const PLACEHOLDER_MONTAGE_LAYOUT_FOR_PLATE_FORMAT = {
  96: 'SINGLE',
  24: 'SQUARE_2X2',
  12: 'SQUARE_3X3',
  6: 'SQUARE_4X4',
}

/**
 * Return a montage layout suitable for placeholder UIs.
 */
export function defaultMontageLayout(plateDims?: PlateDimensions): MontageLayout {
  const numWellsInPlateFormat = plateDims ? plateDims.rows * plateDims.columns : 96
  return PLACEHOLDER_MONTAGE_LAYOUT_FOR_PLATE_FORMAT[numWellsInPlateFormat] ?? 'SINGLE'
}
